import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import api from '../services/api';

const PendingApprovalsContext = createContext();

export const usePendingApprovals = () => {
  const context = useContext(PendingApprovalsContext);
  if (!context) {
    throw new Error('usePendingApprovals must be used within a PendingApprovalsProvider');
  }
  return context;
};

export const PendingApprovalsProvider = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const location = useLocation();
  const [pendingCount, setPendingCount] = useState(0);

  const refreshPendingCount = useCallback(async () => {
    if (authLoading || user?.role !== 'admin') {
      if (!authLoading && user?.role !== 'admin') {
        setPendingCount(0);
      }
      return;
    }

    try {
      const response = await api.get('/api/users/admin/stats');
      setPendingCount(response.data.stats.pending_submissions || 0);
    } catch (error) {
      if (error.response?.status !== 401) {
        console.error('Failed to fetch pending approvals count:', error);
      }
    }
  }, [authLoading, user?.role]);

  useEffect(() => {
    refreshPendingCount();
  }, [refreshPendingCount, location.pathname]);

  const value = {
    pendingCount,
    refreshPendingCount,
  };

  return (
    <PendingApprovalsContext.Provider value={value}>
      {children}
    </PendingApprovalsContext.Provider>
  );
};
